<template>
  <Headers :type="prop.type" :countDown="prop.countDown"> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <!-- <p class="cardName">{{ prop.cardName }}</p> -->
    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div :class="[deviceType, 'inner']">
        <div class="line">
          <div :class="[deviceType, 'summary']">
            {{ t("ccOnBoarding.summary.header") }}
          </div>
          <!--------------------- Basic Information --------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <div class="line">
            <p class="title">
              1. {{ t("ccOnBoarding.summary.basicInformation.title") }}
            </p>
          </div>
          <div class="label-box">
            <span class="span">{{
              t("ccOnBoarding.summary.basicInformation.fullName")
            }}</span>
            <p class="label">
              {{ resData.webFormDetails.basicInformation.fullName }}
            </p>
          </div>
          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.idType")
                }}</span>
                <p
                  v-if="
                    resData.webFormDetails.basicInformation.idTypeCode ==
                    'Passport Number'
                  "
                  class="label"
                >
                  {{ t("ccOnBoarding.summary.basicInformation.passport") }}
                </p>
                <p v-else class="label">
                  {{ resData.webFormDetails.basicInformation.idTypeCode }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span
                  v-if="
                    resData.webFormDetails.oriBasicInformation.idTypeCode != '1'
                  "
                  class="span"
                  >{{ t("ccOnBoarding.summary.basicInformation.ic") }}</span
                >
                <span
                  v-if="
                    resData.webFormDetails.oriBasicInformation.idTypeCode == '1'
                  "
                  class="span"
                  >{{
                    t("ccOnBoarding.summary.basicInformation.passportNumber")
                  }}</span
                >
                <p class="label">
                  {{ resData.webFormDetails.basicInformation.idNo }}
                </p>
              </div>
            </div>
          </div>

          <div
            v-if="resData.webFormDetails.basicInformation.militaryNo != ''"
            class="label-box"
          >
            <span
              v-if="
                resData.webFormDetails.oriBasicInformation.idTypeCode == '2'
              "
              class="span"
              >{{ t("ccOnBoarding.summary.basicInformation.myTentera") }}</span
            >
            <span
              v-else-if="
                resData.webFormDetails.oriBasicInformation.idTypeCode == '3'
              "
              class="span"
              >{{ t("ccOnBoarding.summary.basicInformation.myPolis") }}</span
            >
            <p class="label">
              {{ resData.webFormDetails.basicInformation.militaryNo }}
            </p>
          </div>

          <div
            v-if="resData.webFormDetails.basicInformation.oldIc != ''"
            class="label-box"
          >
            <span class="span">{{
              t("ccOnBoarding.summary.basicInformation.oldIc")
            }}</span>
            <p class="label">
              {{ resData.webFormDetails.basicInformation.oldIc }}
            </p>
          </div>

          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.nationality")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.basicInformation.nationalityCode }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.dob")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.basicInformation.dateOfBirth }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="prop.cardId == 'JC'" class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.jcklMembershipNo")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.basicInformation.jcklMembershipNo }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.jcklClubStatus")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.basicInformation.jcklClubStatus }}
                </p>
              </div>
            </div>
          </div>
          <div class="label-box">
            <span class="span">{{
              t("ccOnBoarding.summary.basicInformation.email")
            }}</span>
            <p class="label">
              {{ resData.webFormDetails.basicInformation.emailAddress }}
            </p>
          </div>
          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.countryCode")
                }}</span>
                <p class="label">
                  +{{
                    resData.webFormDetails.basicInformation.mobileCountryCode
                  }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.mobileNo")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.basicInformation.mobileNumber }}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="
              resData.webFormDetails.basicInformation.homePhoneCountryCode != ''
            "
            class="container"
          >
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.homeCountryCode")
                }}</span>
                <p class="label">
                  +{{
                    resData.webFormDetails.basicInformation.homePhoneCountryCode
                  }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.homeNo")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.basicInformation.homePhoneNumber }}
                </p>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.grossMonthlySalary")
                }}</span>
                <p class="label">
                  {{
                    formattedGrossMonthlySalary(
                      resData.webFormDetails.basicInformation
                        .grossMonthlySalary,
                    )
                  }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.netMonthlySalary")
                }}</span>
                <p class="label">
                  {{
                    formattedGrossMonthlySalary(
                      resData.webFormDetails.basicInformation.netMonthlySalary,
                    )
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.profession")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.basicInformation.professionCode }}
                </p>
              </div>
            </div>
            <div
              v-if="
                resData.webFormDetails.basicInformation.professionOthers != ''
              "
              class="flex_half"
            >
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.basicInformation.profession")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.basicInformation.professionOthers }}
                </p>
              </div>
            </div>
          </div>
          <div class="label-box">
            <span class="span">{{
              t("ccOnBoarding.summary.basicInformation.question")
            }}</span>
            <p class="label">
              {{
                resData.webFormDetails.basicInformation.anyLoan == false
                  ? "No"
                  : "Yes"
              }}
            </p>
          </div>
          <div
            v-if="resData.webFormDetails.basicInformation.anyLoan == true"
            class="label-box"
          >
            <span class="span">{{
              t("ccOnBoarding.summary.basicInformation.repayment")
            }}</span>
            <p class="label">
              {{
                formattedGrossMonthlySalary(
                  resData.webFormDetails.basicInformation.repayment,
                )
              }}
            </p>
          </div>

          <!------------------- Personal Information -------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <div class="line">
            <div :class="[deviceType, 'container']">
              <div class="flex_left">
                <p class="title">
                  2. {{ t("ccOnBoarding.summary.personalInformation.title") }}
                </p>
              </div>
              <div
                class="flex_right"
                @click="
                  !(prop.type == 'PF_CC' || prop.type == 'EP_CC')
                    ? personalJump()
                    : additionalJump('Personal_Information')
                "
              >
                <img
                  src="../../../assets/icons/ButtonEdit.svg"
                  alt="My Happy SVG"
                  class="svg"
                />
              </div>
            </div>
          </div>
          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.title2")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.personInformation.title }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.gender")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.personInformation.genderCode }}
                </p>
              </div>
            </div>
          </div>
          <div class="container">
            <div
              :class="
                resData.webFormDetails.personInformation.raceCode == 'Others'
                  ? 'flex_one_third'
                  : 'flex_half'
              "
            >
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.race")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.personInformation.raceCode }}
                </p>
              </div>
            </div>
            <div
              v-if="
                resData.webFormDetails.personInformation.raceCode == 'Others'
              "
              class="flex_one_third"
            >
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.otherRace")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.personInformation.otherRace }}
                </p>
              </div>
            </div>
            <div
              :class="
                resData.webFormDetails.personInformation.raceCode == 'Others'
                  ? 'flex_one_third'
                  : 'flex_half'
              "
            >
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.residencyStatus")
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.residencyStatusCode
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.maritalStatus")
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.maritalStatusCode
                  }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.motherMaidenName")
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.motherMaidenName
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.noOfDependency")
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.numberOfDependents
                  }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.academic")
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation
                      .academicQualification
                  }}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="
              resData.webFormDetails.personInformation.otherQualification != ''
            "
            class="container"
          >
            <div class="flex_half"></div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.otherAcademic")
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.otherQualification
                  }}
                </p>
              </div>
            </div>
          </div>

          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t(
                    "ccOnBoarding.summary.personalInformation.residentialAddress1",
                  )
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.residentialAddress
                      .addressLine1
                  }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t(
                    "ccOnBoarding.summary.personalInformation.residentialAddress2",
                  )
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.residentialAddress
                      .addressLine2 || "-"
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t(
                    "ccOnBoarding.summary.personalInformation.residentialAddress3",
                  )
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.residentialAddress
                      .addressLine3 || "-"
                  }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.postCode")
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.residentialAddress
                      .postcode
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.city")
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.residentialAddress
                      .city
                  }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.state")
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.residentialAddress
                      .state
                  }}
                </p>
              </div>
            </div>
          </div>

          <div class="container">
            <div class="flex_one_third">
              <div class="label-box">
                <span class="span">{{
                  t(
                    "ccOnBoarding.summary.personalInformation.residentialOwnership",
                  )
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation
                      .residentialOwnership
                  }}
                </p>
              </div>
            </div>
            <div class="flex_one_third">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.yearOfStay")
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.residentialAddress
                      .durationOfStay.year
                  }}
                </p>
              </div>
            </div>
            <div class="flex_one_third">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.personalInformation.monthOfStay")
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.personInformation.residentialAddress
                      .durationOfStay.month
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="label-box">
            <span class="span">{{
              t("ccOnBoarding.summary.personalInformation.permanent")
            }}</span>
            <p
              class="label"
              v-if="
                resData.webFormDetails.personInformation.permanentAddress
                  .addressLine1 == null ||
                resData.webFormDetails.personInformation.permanentAddress
                  .addressLine1 == ''
              "
            >
              {{ t("ccOnBoarding.summary.yes") }}
            </p>

            <p class="label" v-else>
              {{ t("ccOnBoarding.summary.no") }}
            </p>
          </div>
          <div
            v-if="
              resData.webFormDetails.personInformation.permanentAddress
                .addressLine1 != null &&
              resData.webFormDetails.personInformation.permanentAddress
                .addressLine1 != ''
            "
          >
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t(
                      "ccOnBoarding.summary.personalInformation.permanentAddress1",
                    )
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.personInformation.permanentAddress
                        .addressLine1
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t(
                      "ccOnBoarding.summary.personalInformation.permanentAddress2",
                    )
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.personInformation.permanentAddress
                        .addressLine2 || "-"
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t(
                      "ccOnBoarding.summary.personalInformation.permanentAddress3",
                    )
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.personInformation.permanentAddress
                        .addressLine3 || "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.personalInformation.postCode")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.personInformation.permanentAddress
                        .postcode
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.personalInformation.city")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.personInformation.permanentAddress
                        .city
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.personalInformation.state")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.personInformation.permanentAddress
                        .state
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!--------------------- Emergency Contact --------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <div class="line">
            <div :class="[deviceType, 'container']">
              <div class="flex_left">
                <p class="title">
                  3. {{ t("ccOnBoarding.summary.emergencyContact.title") }}
                </p>
              </div>
              <div
                v-if="!(prop.type == 'PF_CC' || prop.type == 'EP_CC')"
                class="flex_right"
                @click="emergencyJump"
              >
                <img
                  src="../../../assets/icons/ButtonEdit.svg"
                  alt="My Happy SVG"
                  class="svg"
                />
              </div>
            </div>
          </div>
          <div class="label-box">
            <span class="span">{{
              t("ccOnBoarding.summary.emergencyContact.title2")
            }}</span>
            <p class="label">
              {{ resData.webFormDetails.emergencyContactInfo.title }}
            </p>
          </div>
          <div class="label-box">
            <span class="span">{{
              t("ccOnBoarding.summary.emergencyContact.immediateName")
            }}</span>
            <p class="label">
              {{ resData.webFormDetails.emergencyContactInfo.contactName }}
            </p>
          </div>
          <div class="label-box">
            <span class="span">{{
              t("ccOnBoarding.summary.emergencyContact.relationship")
            }}</span>
            <p class="label">
              {{ resData.webFormDetails.emergencyContactInfo.relationship }}
            </p>
          </div>
          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.emergencyContact.countryCode")
                }}</span>
                <p class="label">
                  +{{
                    resData.webFormDetails.emergencyContactInfo
                      .contactNoCountryCode
                  }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.emergencyContact.mobileNo")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.emergencyContactInfo.contactNo }}
                </p>
              </div>
            </div>
          </div>
          <!-------------------- Employment Details --------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <div
            v-if="
              (resData.webFormDetails.oriBasicInformation.professionCode ==
                '20' &&
                resData.webFormDetails.oriBasicInformation.idTypeCode == '1') ||
              (resData.webFormDetails.oriBasicInformation.professionCode !=
                '20' &&
                resData.webFormDetails.oriBasicInformation.idTypeCode == '1') ||
              (resData.webFormDetails.oriBasicInformation.professionCode !=
                '20' &&
                resData.webFormDetails.oriBasicInformation.idTypeCode != '1')
            "
          >
            <div class="line">
              <div :class="[deviceType, 'container']">
                <div class="flex_left">
                  <p class="title">
                    4. {{ t("ccOnBoarding.summary.employmentDetails.title") }}
                  </p>
                </div>
                <div
                  v-if="!(prop.type == 'PF_CC' || prop.type == 'EP_CC')"
                  class="flex_right"
                  @click="employmentJump"
                >
                  <img
                    src="../../../assets/icons/ButtonEdit.svg"
                    alt="My Happy SVG"
                    class="svg"
                  />
                </div>
                <div
                  v-if="
                    (prop.type == 'PF_CC' || prop.type == 'EP_CC') &&
                    resData.webFormDetails.employmentDetailInfo
                      .occupationType == 'Self Employed'
                  "
                  class="flex_right"
                  @click="additionalJump('Employment_Details')"
                >
                  <img
                    src="../../../assets/icons/ButtonEdit.svg"
                    alt="My Happy SVG"
                    class="svg"
                  />
                </div>
              </div>
            </div>

            <div
              v-if="
                (resData.webFormDetails.oriBasicInformation.idTypeCode == '1' &&
                  resData.webFormDetails.oriBasicInformation.professionCode !=
                    '20') ||
                (resData.webFormDetails.oriBasicInformation.professionCode ==
                  '20' &&
                  resData.webFormDetails.oriBasicInformation.idTypeCode == '1')
              "
              class="label-box"
            >
              <span class="span">{{
                t("ccOnBoarding.summary.employmentDetails.question")
              }}</span>
              <p
                class="label"
                v-if="
                  resData.webFormDetails.employmentDetailInfo.my2ndHome == true
                "
              >
                {{ t("ccOnBoarding.summary.yes") }}
              </p>
              <p class="label" v-else>
                {{ t("ccOnBoarding.summary.no") }}
              </p>
            </div>
            <div
              v-if="
                (resData.webFormDetails.oriBasicInformation.professionCode !=
                  '20' &&
                  resData.webFormDetails.oriBasicInformation.idTypeCode ==
                    '1') ||
                (resData.webFormDetails.oriBasicInformation.professionCode !=
                  '20' &&
                  resData.webFormDetails.oriBasicInformation.idTypeCode != '1')
              "
            >
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.employmentDetails.question2")
                }}</span>
                <p
                  class="label"
                  v-if="
                    resData.webFormDetails.employmentDetailInfo.workInMY ==
                    'true'
                  "
                >
                  {{ t("ccOnBoarding.summary.employmentDetails.malaysia") }}
                </p>
                <p class="label" v-else>
                  {{
                    t("ccOnBoarding.summary.employmentDetails.singapore/Brunei")
                  }}
                </p>
              </div>
              <div class="container">
                <div class="flex_half">
                  <div class="label-box">
                    <span class="span">{{
                      t("ccOnBoarding.summary.employmentDetails.occupationType")
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .occupationType
                      }}
                    </p>
                  </div>
                </div>
                <div class="flex_half">
                  <div class="label-box">
                    <span class="span">{{
                      t("ccOnBoarding.summary.employmentDetails.emplomentType")
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .employmentType
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="container">
                <div
                  v-if="
                    resData.webFormDetails.employmentDetailInfo
                      .occupationType != 'Self Employed'
                  "
                  class="flex_half"
                >
                  <div class="label-box">
                    <span class="span">{{
                      t(
                        "ccOnBoarding.summary.employmentDetails.employmentIncome",
                      )
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo.incomeType
                      }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="
                    resData.webFormDetails.employmentDetailInfo
                      .occupationType == 'Self Employed'
                  "
                  class="flex_half"
                >
                  <div class="label-box">
                    <span class="span">{{
                      t(
                        "ccOnBoarding.summary.employmentDetails.sstRegistrationNo",
                      )
                    }}</span>
                    <p
                      v-if="
                        resData.webFormDetails.employmentDetailInfo
                          .sstRegistrationNo
                      "
                      class="label"
                    >
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .sstRegistrationNo
                      }}
                    </p>
                    <p v-else class="label">-</p>
                  </div>
                </div>
                <div class="flex_half">
                  <div class="label-box">
                    <span class="span">{{
                      t("ccOnBoarding.summary.employmentDetails.companyName")
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo.companyName
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="container">
                <div class="flex_half">
                  <div class="label-box">
                    <span class="span">{{
                      t(
                        "ccOnBoarding.summary.employmentDetails.companyAddressLine1",
                      )
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .companyAddress.addressLine1
                      }}
                    </p>
                  </div>
                </div>
                <div class="flex_half">
                  <div class="label-box">
                    <span class="span">{{
                      t(
                        "ccOnBoarding.summary.employmentDetails.companyAddressLine2",
                      )
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .companyAddress.addressLine2 || "-"
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="container">
                <div class="flex_half">
                  <div class="label-box">
                    <span class="span">{{
                      t(
                        "ccOnBoarding.summary.employmentDetails.companyAddressLine3",
                      )
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .companyAddress.addressLine3 || "-"
                      }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="
                    resData.webFormDetails.employmentDetailInfo.workInMY ==
                    'true'
                  "
                  class="flex_half"
                >
                  <div class="label-box">
                    <span class="span">{{
                      t("ccOnBoarding.summary.employmentDetails.postCode")
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .companyAddress.postcode
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  resData.webFormDetails.employmentDetailInfo.workInMY == 'true'
                "
                class="container"
              >
                <div class="flex_half">
                  <div class="label-box">
                    <span class="span">{{
                      t("ccOnBoarding.summary.employmentDetails.city")
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .companyAddress.city
                      }}
                    </p>
                  </div>
                </div>
                <div class="flex_half">
                  <div class="label-box">
                    <span class="span">{{
                      t("ccOnBoarding.summary.employmentDetails.state")
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .companyAddress.state
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="container">
                <div class="flex_one_third">
                  <div class="label-box">
                    <span class="span">{{
                      t("ccOnBoarding.summary.employmentDetails.countryCode")
                    }}</span>
                    <p class="label">
                      +{{
                        resData.webFormDetails.employmentDetailInfo
                          .companyPhoneNoCountryCode
                      }}
                    </p>
                  </div>
                </div>
                <div class="flex_one_third">
                  <div class="label-box">
                    <span class="span">{{
                      t("ccOnBoarding.summary.employmentDetails.areaCode")
                    }}</span>
                    <p class="label">
                      {{ resData.webFormDetails.employmentDetailInfo.areaCode }}
                    </p>
                  </div>
                </div>
                <div class="flex_one_third">
                  <div class="label-box">
                    <span class="span">{{
                      t(
                        "ccOnBoarding.summary.employmentDetails.companyPhoneNumber",
                      )
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .companyPhoneNo
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="container">
                <div class="flex_half">
                  <div class="label-box">
                    <span class="span">{{
                      t(
                        "ccOnBoarding.summary.employmentDetails.natureOfBusiness",
                      )
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .natureOfBusiness
                      }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="
                    resData.webFormDetails.employmentDetailInfo.otherNOB != ''
                  "
                  class="flex_half"
                >
                  <div class="label-box">
                    <span class="span">{{
                      t("ccOnBoarding.summary.employmentDetails.others")
                    }}</span>
                    <p class="label">
                      {{ resData.webFormDetails.employmentDetailInfo.otherNOB }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="container">
                <div class="flex_half">
                  <div class="label-box">
                    <span class="span">{{
                      t("ccOnBoarding.summary.employmentDetails.yearEmp")
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .lengthOfEmployment.year
                      }}
                    </p>
                  </div>
                </div>
                <div class="flex_half">
                  <div class="label-box">
                    <span class="span">{{
                      t("ccOnBoarding.summary.employmentDetails.monthEmp")
                    }}</span>
                    <p class="label">
                      {{
                        resData.webFormDetails.employmentDetailInfo
                          .lengthOfEmployment.month
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!------------------ Principal Card Details ------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <div class="line">
            <div :class="[deviceType, 'container']">
              <div class="flex_left">
                <span class="title">
                  <div
                    v-if="
                      (resData.webFormDetails.oriBasicInformation
                        .professionCode != '20' &&
                        resData.webFormDetails.oriBasicInformation.idTypeCode ==
                          '1') ||
                      (resData.webFormDetails.oriBasicInformation
                        .professionCode != '20' &&
                        resData.webFormDetails.oriBasicInformation.idTypeCode !=
                          '1') ||
                      (resData.webFormDetails.oriBasicInformation
                        .professionCode == '20' &&
                        resData.webFormDetails.oriBasicInformation.idTypeCode ==
                          '1')
                    "
                  >
                    5.
                    {{ t("ccOnBoarding.summary.principalCardDetails.title") }}
                  </div>
                  <div v-else>
                    4.
                    {{ t("ccOnBoarding.summary.principalCardDetails.title") }}
                  </div>
                </span>
              </div>
              <div
                class="flex_right"
                @click="
                  !(prop.type == 'PF_CC' || prop.type == 'EP_CC')
                    ? principalJump()
                    : additionalJump('Principal_Card_Details')
                "
              >
                <img
                  src="../../../assets/icons/ButtonEdit.svg"
                  alt="My Happy SVG"
                  class="svg"
                />
              </div>
            </div>
          </div>
          <div class="label-box">
            <span class="span">{{
              t("ccOnBoarding.summary.principalCardDetails.nameOnCard")
            }}</span>
            <p class="label">
              {{ resData.webFormDetails.principalCardDetail.name }}
            </p>
          </div>
          <div class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t(
                    "ccOnBoarding.summary.principalCardDetails.cardDeliveryOption",
                  )
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.principalCardDetail.deliveryOption
                  }}
                </p>
              </div>
            </div>
            <div
              v-if="
                resData.webFormDetails.principalCardDetail.deliveryOption ==
                'Branch'
              "
              class="flex_half"
            >
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.principalCardDetails.branch")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.principalCardDetail.branchValue }}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="
              resData.webFormDetails.principalCardDetail.deliveryOption ==
              'Home'
            "
          >
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t(
                      "ccOnBoarding.summary.principalCardDetails.deliveryAddress1",
                    )
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.principalCardDetail.deliveryAddress
                        .addressLine1
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t(
                      "ccOnBoarding.summary.principalCardDetails.deliveryAddress2",
                    )
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.principalCardDetail.deliveryAddress
                        .addressLine2 || "-"
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t(
                      "ccOnBoarding.summary.principalCardDetails.deliveryAddress3",
                    )
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.principalCardDetail.deliveryAddress
                        .addressLine3 || "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.principalCardDetails.postCode")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.principalCardDetail.deliveryAddress
                        .postcode
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.principalCardDetails.city")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.principalCardDetail.deliveryAddress
                        .city
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.principalCardDetails.state")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.principalCardDetail.deliveryAddress
                        .state
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="prop.cardId == 'JC'" class="container">
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t(
                    "ccOnBoarding.summary.principalCardDetails.jcklClubBillPeriod",
                  )
                }}</span>
                <p class="label">
                  {{
                    resData.webFormDetails.principalCardDetail
                      .jcklClubBillPeriod
                  }}
                </p>
              </div>
            </div>
            <div class="flex_half">
              <div class="label-box">
                <span class="span">{{
                  t("ccOnBoarding.summary.principalCardDetails.jcklFeeAmount")
                }}</span>
                <p class="label">
                  {{ resData.webFormDetails.principalCardDetail.jcklFeeAmount }}
                </p>
              </div>
            </div>
          </div>
          <div class="label-box">
            <span class="span">{{
              t("ccOnBoarding.summary.principalCardDetails.statement")
            }}</span>
            <p
              v-if="resData.webFormDetails.principalCardDetail.eStatement"
              class="label"
            >
              {{ t("ccOnBoarding.summary.yes") }}
            </p>
            <p v-else class="label">
              {{ t("ccOnBoarding.summary.no") }}
            </p>
          </div>
          <div
            v-if="!resData.webFormDetails.principalCardDetail.eStatement"
            class="label-box"
          >
            <span class="span">{{
              t("ccOnBoarding.summary.principalCardDetails.billingAddress")
            }}</span>
            <p class="label">
              {{ resData.webFormDetails.principalCardDetail.billingAddress }}
            </p>
          </div>
          <!--------------------- Upload Document ----------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <div class="line">
            <div :class="[deviceType, 'container']">
              <div class="flex_left">
                <span class="title">
                  <div
                    v-if="
                      (resData.webFormDetails.oriBasicInformation
                        .professionCode != '20' &&
                        resData.webFormDetails.oriBasicInformation.idTypeCode ==
                          '1') ||
                      (resData.webFormDetails.oriBasicInformation
                        .professionCode != '20' &&
                        resData.webFormDetails.oriBasicInformation.idTypeCode !=
                          '1') ||
                      (resData.webFormDetails.oriBasicInformation
                        .professionCode == '20' &&
                        resData.webFormDetails.oriBasicInformation.idTypeCode ==
                          '1')
                    "
                  >
                    6. {{ t("ccOnBoarding.summary.uploadDocument.title") }}
                  </div>
                  <div v-else>
                    5. {{ t("ccOnBoarding.summary.uploadDocument.title") }}
                  </div>
                </span>
              </div>
              <div class="flex_right" @click="uploadJump">
                <img
                  src="../../../assets/icons/ButtonEdit.svg"
                  alt="My Happy SVG"
                  class="svg"
                />
              </div>
            </div>
          </div>
          <div class="label-box">
            <span class="span">{{
              t("ccOnBoarding.summary.uploadDocument.proofIdentity")
            }}</span>
            <FileList
              v-if="prop.ccForm.ekyc.status != 'COMPLETE'"
              :question="prop.ccForm.uploadDocument.proofIdentity"
              :mosIdentityFile="prop.ccForm.MosUploadDocument.proofIdentity"
              :deletes="false"
              :border="false"
              :type="prop.type"
              :pfExpired="prop.pfExpired"
              :hide-in-summary="false"
              :completedInCC="prop.ccForm.ekyc.completedInCC"
              :third-party-file="prop.ccForm.EPCCUploadDocument.proofIdentity"
            ></FileList>
            <FileList
              v-else-if="prop.ccForm.ekyc.status == 'COMPLETE'"
              :question="prop.ccForm.uploadDocument.proofIdentity"
              :mosIdentityFile="prop.ccForm.MosUploadDocument.proofIdentity"
              :deletes="false"
              :border="false"
              :status="prop.ccForm.ekyc.status"
              :type="prop.type"
              :pfExpired="prop.pfExpired"
              :hide-in-summary="false"
              :completedInCC="prop.ccForm.ekyc.completedInCC"
              :third-party-file="prop.ccForm.EPCCUploadDocument.proofIdentity"
            ></FileList>
          </div>
          <div
            v-if="
              prop.ccForm.uploadDocument.proofIncome.fileNumber != 0 ||
              prop.ccForm.MosUploadDocument.proofIncome.fileNumber != 0 ||
              prop.ccForm.EPCCUploadDocument.proofIncome.fileNumber != 0
            "
            class="label-box"
          >
            <span class="span">{{
              t("ccOnBoarding.summary.uploadDocument.proofIncome")
            }}</span>
            <FileList
              :question="prop.ccForm.uploadDocument.proofIncome"
              :mosIncomeFile="prop.ccForm.MosUploadDocument.proofIncome"
              :deletes="false"
              :border="false"
              :hide-in-summary="false"
              :third-party-file="prop.ccForm.EPCCUploadDocument.proofIncome"
            ></FileList>
          </div>
          <div
            v-if="
              prop.cardId == 'JC' &&
              prop.ccForm.uploadDocument.proofJCKL.fileNumber != 0
            "
            class="label-box"
          >
            <span class="span">{{
              t("ccOnBoarding.summary.uploadDocument.proofJCKL")
            }}</span>
            <FileList
              :question="prop.ccForm.uploadDocument.proofJCKL"
              :deletes="false"
              :border="false"
            ></FileList>
          </div>
          <!-- <div
          v-if="prop.ccForm.uploadDocument.additional.fileNumber != 0"
          class="label-box"
        >
          <span class="span">{{
            t("ccOnBoarding.summary.uploadDocument.additionalDoc")
          }}</span>
          <FileList
            :question="prop.ccForm.uploadDocument.additional"
            :deletes="false"
            :border="false"
          ></FileList>
        </div> -->

          <!-------------------- Supplementary Card --------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <div
            v-if="
              !(prop.type == 'PF_CC' || prop.type == 'EP_CC') &&
              !(prop.acc == 'M1' || prop.acc == 'M7')
            "
            class="line"
          >
            <div :class="[deviceType, 'container']">
              <div class="flex_left">
                <span class="title">
                  <div
                    v-if="
                      (resData.webFormDetails.oriBasicInformation
                        .professionCode != '20' &&
                        resData.webFormDetails.oriBasicInformation.idTypeCode ==
                          '1') ||
                      (resData.webFormDetails.oriBasicInformation
                        .professionCode != '20' &&
                        resData.webFormDetails.oriBasicInformation.idTypeCode !=
                          '1') ||
                      (resData.webFormDetails.oriBasicInformation
                        .professionCode == '20' &&
                        resData.webFormDetails.oriBasicInformation.idTypeCode ==
                          '1')
                    "
                  >
                    7.
                    {{ t("ccOnBoarding.summary.supplementaryDetails.title") }}
                  </div>
                  <div v-else>
                    6.
                    {{ t("ccOnBoarding.summary.supplementaryDetails.title") }}
                  </div>
                </span>
              </div>
              <div class="flex_right" @click="suppCardJump">
                <img
                  src="../../../assets/icons/ButtonEdit.svg"
                  alt="My Happy SVG"
                  class="svg"
                />
              </div>
            </div>
          </div>
          <div
            v-if="
              !(prop.type == 'PF_CC' || prop.type == 'EP_CC') &&
              !(prop.acc == 'M1' || prop.acc == 'M7')
            "
            class="label-box"
          >
            <span class="span">{{
              t("ccOnBoarding.summary.supplementaryDetails.question1")
            }}</span>
            <p class="label">
              {{ resData.webFormDetails.supp.isSupp }}
            </p>
          </div>
          <div
            v-if="
              !(prop.acc == 'M1' || prop.acc == 'M7') &&
              !(prop.type == 'PF_CC' || prop.type == 'EP_CC') &&
              resData.webFormDetails.supp.isSupp == 'Yes'
            "
          >
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.titles")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .titleValue
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.fullName")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .fullName
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.idType")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .idTypeValue
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span
                    v-if="
                      resData.webFormDetails.supplementaryInformation[0]
                        .idTypeCode == '0'
                    "
                    class="span"
                    >{{
                      t("ccOnBoarding.summary.supplementaryDetails.ic")
                    }}</span
                  >
                  <span
                    v-if="
                      resData.webFormDetails.supplementaryInformation[0]
                        .idTypeCode == '1'
                    "
                    class="span"
                    >{{
                      t(
                        "ccOnBoarding.summary.supplementaryDetails.passportNumber",
                      )
                    }}</span
                  >
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0].idNo
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.nameOnCard")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .nameOnCard
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.nationality")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .nationalityValue
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.dob")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .dateOfBirth
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.gender")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .genderValue
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.race")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .raceValue
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box"></div>
              </div>
              <div
                v-if="
                  resData.webFormDetails.supplementaryInformation[0].raceCode ==
                  '004'
                "
                class="flex_half"
              >
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.otherRace")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .otherRace
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t(
                      "ccOnBoarding.summary.supplementaryDetails.motherMaidenName",
                    )
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .motherMaidenName
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.relationship")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .relationshipValue
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.email")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .emailAddress
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.countryCode")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .mobileNoCountryCode
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.mobileNo")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .mobileNo
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t(
                      "ccOnBoarding.summary.supplementaryDetails.residentialAddress1",
                    )
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .residentialAddress.addressLine1
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t(
                      "ccOnBoarding.summary.supplementaryDetails.residentialAddress2",
                    )
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .residentialAddress.addressLine2 || "-"
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t(
                      "ccOnBoarding.summary.supplementaryDetails.residentialAddress3",
                    )
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .residentialAddress.addressLine3 || "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.postCode")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .residentialAddress.postcode
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.city")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .residentialAddress.city
                    }}
                  </p>
                </div>
              </div>
              <div class="flex_half">
                <div class="label-box">
                  <span class="span">{{
                    t("ccOnBoarding.summary.supplementaryDetails.state")
                  }}</span>
                  <p class="label">
                    {{
                      resData.webFormDetails.supplementaryInformation[0]
                        .residentialAddress.state
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!------------- Supplementary Upload Document ----------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <!------------------------------------------------------------->
          <div
            v-if="
              !(prop.acc == 'M1' || prop.acc == 'M7') &&
              !(prop.type == 'PF_CC' || prop.type == 'EP_CC') &&
              resData.webFormDetails.supp.isSupp == 'Yes' &&
              prop.ccForm.supplementaryUploadDocument.proofIdentity
                .fileNumber != 0
            "
          >
            <div class="line">
              <div :class="[deviceType, 'container']">
                <div class="flex_left">
                  <span class="title">
                    <div
                      v-if="
                        (resData.webFormDetails.oriBasicInformation
                          .professionCode != '20' &&
                          resData.webFormDetails.oriBasicInformation
                            .idTypeCode == '1') ||
                        (resData.webFormDetails.oriBasicInformation
                          .professionCode != '20' &&
                          resData.webFormDetails.oriBasicInformation
                            .idTypeCode != '1') ||
                        (resData.webFormDetails.oriBasicInformation
                          .professionCode == '20' &&
                          resData.webFormDetails.oriBasicInformation
                            .idTypeCode == '1')
                      "
                    >
                      8.
                      {{ t("ccOnBoarding.summary.supplementaryUpload.title") }}
                    </div>
                    <div v-else>
                      7.
                      {{ t("ccOnBoarding.summary.supplementaryUpload.title") }}
                    </div>
                  </span>
                </div>
                <div class="flex_right" @click="suppCardUploadJump">
                  <img
                    src="../../../assets/icons/ButtonEdit.svg"
                    alt="My Happy SVG"
                    class="svg"
                  />
                </div>
              </div>
            </div>

            <div class="label-box">
              <span class="span">{{
                t("ccOnBoarding.summary.uploadDocument.proofIdentity")
              }}</span>
              <FileList
                :question="
                  prop.ccForm.supplementaryUploadDocument.proofIdentity
                "
                :deletes="false"
                :border="false"
              ></FileList>
            </div>
          </div>
        </div>
      </div>

      <div :class="[deviceType, 'buttoncontainer']">
        <div :class="[deviceType, 'left-button']"></div>
        <button :class="[deviceType, 'right-button']">
          {{ t("ccOnBoarding.next") }}
        </button>
      </div>
    </Form>
  </div>
  <div v-if="prop.overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, onBeforeMount, type PropType } from "vue";
import Headers from "./components/Headers.vue";
import i18n from "@/plugin/i18n";
import { Form } from "vee-validate";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import type FormCC from "@/interface/FormCC";
import FileList from "./components/UploadedFileList.vue";
import { StringSchema, string } from "yup";
import { deviceDetect } from "mobile-device-detect";

const deviceType = ref("");

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

const prop = defineProps({
  ccForm: {
    type: Object as PropType<FormCC>,
    required: true,
  },
  cardId: {
    type: String,
  },
  cardName: {
    type: String,
    required: true,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  type: {
    type: String,
  },
  countDown: {
    type: String,
  },
  token: {
    type: String,
    required: true,
  },
  pfExpired: {
    type: Boolean,
    default: false,
  },
  acc: {
    type: String,
  },
});

interface CardDetail {
  webFormRequestId: string;
  webFormDetails: {
    basicInformation: {
      fullName: string;
      idTypeCode: string;
      idNo: string;
      oldIc: string;
      militaryNo: string;
      nationalityCode: string;
      dateOfBirth: string;
      emailAddress: string;
      grossMonthlySalary: Number;
      netMonthlySalary: Number;
      professionCode: string;
      professionOthers: string;
      mobileCountryCode: string;
      mobileNumber: string;
      anyLoan: boolean;
      homePhoneNumber: string;
      homePhoneCountryCode: string;
      repayment: Number;
      jcklMembershipNo: string;
      jcklClubStatus: string;
    };
    oriBasicInformation: {
      fullName: string;
      idTypeCode: string;
      idNo: string;
      oldIc: string;
      militaryNo: string;
      nationalityCode: string;
      dateOfBirth: string;
      emailAddress: string;
      grossMonthlySalary: Number;
      netMonthlySalary: Number;
      professionCode: string;
      professionOthers: string;
      mobileCountryCode: string;
      mobileNumber: string;
      anyLoan: boolean;
      homePhoneNumber: string;
      homePhoneCountryCode: string;
      repayment: Number;
    };
    personInformation: {
      title: string;
      genderCode: string;
      raceCode: string;
      otherRace: string;
      residencyStatusCode: string;
      maritalStatusCode: string;
      motherMaidenName: string;
      numberOfDependents: string;
      academicQualification: string;
      otherQualification: string;
      residentialAddress: {
        addressLine1: string;
        addressLine2: string;
        addressLine3: string;
        postcode: string;
        city: string;
        state: string;
        durationOfStay: {
          year: Number;
          month: Number;
        };
      };
      residentialOwnership: string;
      permanentAddress: {
        addressLine1: string;
        addressLine2: string;
        addressLine3: string;
        postcode: string;
        city: string;
        state: string;
      };
    };
    emergencyContactInfo: {
      title: string;
      contactName: string;
      relationship: string;
      contactNoCountryCode: string;
      contactNo: string;
    };
    employmentDetailInfo: {
      my2ndHome: boolean;
      workInMY: string;
      occupationType: string;
      employmentType: string;
      incomeType: string;
      companyName: string;
      sstRegistrationNo: string;
      companyAddress: {
        addressLine1: string;
        addressLine2: string;
        addressLine3: string;
        postcode: string;
        city: string;
        state: string;
      };
      companyPhoneNoCountryCode: string;
      companyPhoneNo: string;
      natureOfBusiness: string;
      otherNOB: string;
      lengthOfEmployment: {
        year: string;
        month: string;
      };
      areaCode: string;
    };
    principalCardDetail: {
      name: string;
      deliveryOption: string;
      branchName: string;
      branchValue: string;
      deliveryAddress: {
        addressLine1: string;
        addressLine2: string;
        addressLine3: string;
        postcode: string;
        city: string;
        state: string;
      };
      eStatement: boolean;
      billingAddress: string;
      jcklClubBillPeriod: string;
      jcklFeeAmount: string;
    };
    supp: {
      isSupp: string;
    };
    terms: {
      promotionFlag: string;
    };
    supplementaryInformation: [
      {
        title: string;
        titleValue: string;
        fullName: string;
        nameOnCard: string;
        relationship: string;
        relationshipValue: string;
        nationalityCode: string;
        nationalityValue: string;
        dateOfBirth: string;
        idTypeCode: string;
        idTypeValue: string;
        idNo: string;
        genderCode: string;
        genderValue: string;
        raceCode: string;
        raceValue: string;
        otherRace: string;
        motherMaidenName: string;
        emailAddress: string;
        mobileNoCountryCode: string;
        mobileNo: string;
        residentialAddress: {
          addressLine1: string;
          addressLine2: string;
          addressLine3: string;
          postcode: string;
          city: string;
          state: string;
        };
      },
    ];
  };
}

let resData = ref<CardDetail>({
  webFormRequestId: "",
  webFormDetails: {
    basicInformation: {
      fullName: "",
      idTypeCode: "",
      idNo: "",
      oldIc: "",
      militaryNo: "",
      nationalityCode: "",
      dateOfBirth: "",
      emailAddress: "",
      grossMonthlySalary: 0,
      netMonthlySalary: 0,
      professionCode: "",
      professionOthers: "",
      mobileCountryCode: "",
      mobileNumber: "",
      anyLoan: true,
      homePhoneNumber: "",
      homePhoneCountryCode: "",
      repayment: 0,
      jcklMembershipNo: "",
      jcklClubStatus: "",
    },
    oriBasicInformation: {
      fullName: "",
      idTypeCode: "",
      idNo: "",
      oldIc: "",
      militaryNo: "",
      nationalityCode: "",
      dateOfBirth: "",
      emailAddress: "",
      grossMonthlySalary: 0,
      netMonthlySalary: 0,
      professionCode: "",
      professionOthers: "",
      mobileCountryCode: "",
      mobileNumber: "",
      anyLoan: true,
      homePhoneNumber: "",
      homePhoneCountryCode: "",
      repayment: 0,
    },
    personInformation: {
      title: "",
      genderCode: "",
      raceCode: "",
      otherRace: "",
      residencyStatusCode: "",
      maritalStatusCode: "",
      motherMaidenName: "",
      numberOfDependents: "",
      academicQualification: "",
      otherQualification: "",
      residentialAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        postcode: "",
        city: "",
        state: "",
        durationOfStay: {
          year: 0,
          month: 0,
        },
      },
      residentialOwnership: "",
      permanentAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        postcode: "",
        city: "",
        state: "",
      },
    },
    emergencyContactInfo: {
      title: "",
      contactName: "",
      relationship: "",
      contactNoCountryCode: "",
      contactNo: "",
    },
    employmentDetailInfo: {
      my2ndHome: true,
      workInMY: "",
      occupationType: "",
      employmentType: "",
      incomeType: "",
      companyName: "",
      sstRegistrationNo: "",
      companyAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        postcode: "",
        city: "",
        state: "",
      },
      companyPhoneNoCountryCode: "",
      companyPhoneNo: "",
      natureOfBusiness: "",
      otherNOB: "",
      lengthOfEmployment: {
        year: "",
        month: "",
      },
      areaCode: "",
    },
    principalCardDetail: {
      name: "",
      deliveryOption: "",
      branchName: "",
      deliveryAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        postcode: "",
        city: "",
        state: "",
      },
      eStatement: true,
      billingAddress: "",
      branchValue: "",
      jcklClubBillPeriod: "",
      jcklFeeAmount: "",
    },
    terms: {
      promotionFlag: "",
    },
    supp: {
      isSupp: "",
    },
    supplementaryInformation: [
      {
        title: "",
        titleValue: "",
        fullName: "",
        nameOnCard: "",
        relationship: "",
        relationshipValue: "",
        nationalityCode: "",
        nationalityValue: "",
        dateOfBirth: "",
        idTypeCode: "",
        idTypeValue: "",
        idNo: "",
        genderCode: "",
        genderValue: "",
        raceCode: "",
        raceValue: "",
        otherRace: "",
        motherMaidenName: "",
        emailAddress: "",
        mobileNoCountryCode: "",
        mobileNo: "",
        residentialAddress: {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          postcode: "",
          city: "",
          state: "",
        },
      },
    ],
  },
});

onBeforeMount(() => {
  const requestModel = {
    webFormRequestId: prop.ccForm.webFormRequestId,
    cardId: prop.cardId,
    icNumber: prop.ccForm.basicInformation.idNo,
    customerName: prop.ccForm.basicInformation.name,
  };
  MasterService.validate(requestModel, prop.token)
    .then((res) => {
      if (res.status == 200) {
        resData.value = res.data.responseModel.cardList[0];
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        emit("tokenSessionTimeOut");
      }
    });

  window.scrollTo({ top: 0, behavior: "smooth" });
});

const formattedGrossMonthlySalary = (salary: Number) => {
  const formattedSalary = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(salary));

  return formattedSalary;
};

const { t } = i18n.global;

const schema = computed(() => {
  return {};
});

const onInvalidSubmit = () => {};

const emit = defineEmits([
  "submit",
  "jumpStep",
  "tokenSessionTimeOut",
  "getProductStep",
]);

const onSubmit = () => {
  emit("submit");
};

const additionalJump = (button: String) => {
  prop.ccForm.summarySetting.additionalInformationJump = true;
  //TODO-Matrix
  emit("getProductStep", false, false, false, false, button);
};

const personalJump = () => {
  prop.ccForm.summarySetting.personalInformationJump = true;
  emit("jumpStep", "4", "", "10");
};

const emergencyJump = () => {
  prop.ccForm.summarySetting.emergencyContactJump = true;
  emit("jumpStep", "5", "", "10");
};

const employmentJump = () => {
  prop.ccForm.summarySetting.employmentDetailsJump = true;
  emit("jumpStep", "6", "", "10");
};

const principalJump = () => {
  prop.ccForm.summarySetting.principalCardDetailsJump = true;
  emit("jumpStep", "7", "", "10");
};

const uploadJump = () => {
  prop.ccForm.summarySetting.uploadDocumentsJump = true;
  if (prop.type == "PF_CC" || prop.type == "EP_CC") {
    //TODO-Matrix
    emit("getProductStep", false, false, false, false, "Upload_Documents");
  } else {
    emit("jumpStep", "8", "", "10");
  }
};

const suppCardJump = () => {
  prop.ccForm.summarySetting.supplementaryCardDetailsJump = true;
  emit("jumpStep", "9", "", "10");
};

const suppCardUploadJump = () => {
  prop.ccForm.summarySetting.supplementaryUploadFileJump = true;
  emit("jumpStep", "11", "", "10");
};
</script>

<style scoped>
.cardName {
  color: rgba(0, 0, 0, 0.38);
  font: 500 16px/130% "Outfit";
  margin-bottom: 10px;
  margin-top: 5px;
  text-align: left;
  position: relative;
  align-self: stretch;
}

.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.summary {
  color: #111111;
  text-align: left;
  font: 500 24px/130% "Outfit";
  position: relative;
}

.help {
  color: red;
  margin-bottom: 0px;
  font:
    400 16px/130% "Outfit",
    sans-serif;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 500;
  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}
.line {
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 10px;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

.left-button {
  flex: 0 0 15%;
}

.title {
  margin-bottom: 10px;
  margin-top: 20px;
  color: rgba(0, 0, 0, 0.87);
  font-size: 16px;
  font-family: "Outfit";
  font-weight: 500;
  line-height: 18.2px;
}

.label-box {
  margin-bottom: 10px;
  padding-right: 10px;
}

.span {
  color: rgba(0, 0, 0, 0.38);
  font-family: "Outfit", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.label {
  color: rgba(0, 0, 0, 0.87);
  font-family: "Outfit", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 0;
}

.container {
  display: flex;
  width: 100%;
  align-items: flex-start;
  align-self: stretch;
  padding: 0;
  margin: 0;
}

.flex_half {
  width: 50%;
}

.flex_one_third {
  width: 33%;
}

.flex_left {
  width: 95%;
}

.flex_right {
  width: 5%;
  margin: auto;
}

.svg {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

@media (max-width: 700px) {
  .buttoncontainer {
    margin-top: 0;
    gap: 10px;
  }

  .left-button {
    flex: 0 0 30%;
    /* display: none; */
  }

  .right-button {
    flex: 0 0 68%;
  }

  .right-button:disabled {
    flex: 0 0 68%;
  }
  .container {
    flex-direction: column;
  }
  .flex_half {
    width: 100%;
  }
  .flex_one_third {
    width: 100%;
  }
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.summary:is(.Mobile) {
  font-size: 18px;
}

.container:is(.Mobile) {
  flex-direction: row;
}

.buttoncontainer:is(.Mobile) {
  /* flex-wrap: wrap;
  display: flex;
  justify-content: space-between; */
  align-items: center;
  padding: 24px 20px 20px 20px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
  /* display: none; */
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

p {
  word-wrap: break-word;
}
</style>
